import {ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit, signal} from '@angular/core';
import {Subscription} from 'rxjs';
import {APP_BASE_HREF} from "@angular/common";

import {BaseTaskComponent} from '../base-task-component';
import {GbgTaskService} from './services/gbg-task.service';
import {PortalConfig} from '@shared/portal-config';
import {GbgStepComponent} from '@shared/components/gbg-step/gbg-step.component';

@Component({
    selector: 'app-gbg-task',
    templateUrl: './gbg-task.component.html',
    styleUrls: ['./gbg-task.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [GbgStepComponent]
})
export class GbgTaskComponent extends BaseTaskComponent implements OnInit, OnDestroy {

  private readonly subscriptions: Subscription = new Subscription();

  readonly nextEnabled = signal(false);
  readonly hasError = signal(false);
  readonly supportMessage = signal('');

  constructor(
    @Inject(APP_BASE_HREF) private readonly baseHref: string,
    private readonly gbgTaskService: GbgTaskService,
    private readonly portalConfig: PortalConfig,
  ) {
    super();
  }

  ngOnInit(): void {
    this.supportMessage.set(this.portalConfig.supportMessage);

    if (this.step().completed) {
      this.nextEnabled.set(true);
      return;
    }

    this.hasError.set(true);
    console.warn('GBG SDK not available - feature not yet implemented');
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  save(journeyId: string): void {
    this.processing = true;

    const subscription = this.gbgTaskService.save(this.task().id, this.step().id, journeyId).subscribe({
      next: updatedTask => {
        this.updateTask(updatedTask);
        this.processing = false;
        this.nextEnabled.set(true);
      },
      error: () => {
        this.processing = false;
      }
    });

    this.subscriptions.add(subscription);
  }
}
